import { formatInternational } from "../phone_number/phone_number.helpers";
import { capitalizeString } from "../string/string.helpers";

import { Speaker } from "@/states/call/speakers/speakers.utility.decl";

export function formatSpeakerDisplay(speakers: Speaker[]): string {
  return speakers
    .flatMap((speaker) => {
      if (!speaker.fullName && !speaker.number) {
        return [];
      }

      if (speaker.fullName) {
        return [capitalizeString(speaker.fullName)];
      }

      if (speaker.number) {
        return [formatInternational(speaker.number)];
      }

      // Just for TypeScript, we should never reach this point.
      return [];
    })
    .join(" - ");
}

export function getSpeakerDisplayName(
  fullName?: string | null,
  number?: string
) {
  if (fullName) {
    return fullName;
  }

  if (number) {
    return formatInternational(number);
  }
  return "";
}
